import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'disableReportSaveButton',
})
export class DisableReportSaveButtonPipe implements PipeTransform {
  constructor() {}

  /**
   * Determines if the save button should be disabled
   *
   * @returns {boolean} True if the button should be disabled
   */
  transform(
    isEditMode: boolean,
    isCallSummaryPopulated: boolean,
    canUserEditCallSummary: boolean,
    isCallSummaryEdited: boolean
  ): boolean {
    return (
      ((!isEditMode || !isCallSummaryPopulated) && !canUserEditCallSummary) ||
      (!isEditMode && canUserEditCallSummary && !isCallSummaryEdited)
    );
  }
}
